import request from '@/utils/request'

// export function login(data) {
//   return request({
//     url: '/vue-admin-template/user/login',
//     method: 'post',
//     data
//   })
// }

// export function getInfo(token) {
//   return request({
//     url: '/vue-admin-template/user/info',
//     method: 'get',
//     params: { token }
//   })
// }

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

// 获取个人信息
export function allUser() {
  return request({
    url: '/PersonalCenter/',
    method: 'get'
  })
}
// 获取管理员权限
export function Guangliyuan() {
  return request({
    url: '/invitation/admin/permission',
    method: 'get'
  })
}

// 确认用户国家语言
export function confirmCountry(data) {
  return request({
    url: '/user/confirmCountry',
    method: 'post',
	data: data
  })
}
// 确认用户国家语言后港服的用户调用成为plus
export function confirmCountrypk(data) {
  return request({
    url: '/user/confirmHkCountry',
	method: 'post',
	data: data
  })
}
// 用户消息
export function message(data) {
  return request({
    url: `/user/message?pageNum=${data.pageNum}&pageSize=${data.pageSize}&type=${data.type}`,
    method: 'get'
  })
}
export function userPdf() {
  return request({
    url: '/user/pdf',
    method: 'get'
  })
}
// 获取我的装机数据
export function myInstallation(data) {
  return request({
    url: `/member/user/myInstallation?pageNum=${data.pageNum}&pageSize=${data.pageSize}&date=${data.date}&model=${data.model}`,
    method: 'get'
  })
}
// 获取全部装机型号
export function installationModel(data) {
  return request({
    url: '/member/user/installationModel',
    method: 'get'
  })
}

